import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { addValueToCache } from './cache';

export const driessenstoffenApi = createApi({
  reducerPath: 'driessenstoffenApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${window.location.protocol}//${window.location.hostname}`,
    prepareHeaders: (headers) => {
      headers.set('accept', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Session', 'Wishlist', 'Categories'],
  endpoints: (builder) => ({
    getSessionInfo: builder.query({
      query: () => 'actions/users/session-info/',
      providesTags: ['Session'],
    }),
    getWishlist: builder.query({
      query: () => 'actions/driessen/wishlist/items/',
      providesTags: ['Wishlist'],
    }),
    getCategories: builder.query({
      query: ({ nodeUrl, siteId }) => ({
        url: `${nodeUrl}api/categories`,
        method: 'POST',
        body: { siteId },
      }),
      providesTags: ['Categories'],
      transformResponse: (data, meta, params) => {
        addValueToCache('getCategories', params, data);
        return data;
      },
    }),
    addToWishlist: builder.mutation({
      invalidatesTags: ['Wishlist'],
      query: ({ elementId, sessionInfo }) => {
        const body = new FormData();
        body.append('action', 'wishlist/items/add');
        body.append(sessionInfo.csrfTokenName, sessionInfo.csrfTokenValue);
        body.append('elementId', elementId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
      onQueryStarted({ elementId }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          driessenstoffenApi.util.updateQueryData('getWishlist', undefined, (draft) => {
            draft.push(elementId);
          }),
        );
        queryFulfilled.catch(patchResult.undo);
      },
    }),
    removeFromWishlist: builder.mutation({
      invalidatesTags: ['Wishlist'],
      query: ({ elementId, sessionInfo }) => {
        const body = new FormData();
        body.append('action', 'wishlist/items/remove');
        body.append(sessionInfo.csrfTokenName, sessionInfo.csrfTokenValue);
        body.append('elementId', elementId);

        return {
          url: '/',
          method: 'POST',
          body,
        };
      },
      onQueryStarted({ elementId }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          driessenstoffenApi.util.updateQueryData('getWishlist', undefined, (draft) => {
            const index = draft.indexOf(elementId);
            if (index > -1) {
              draft.splice(index, 1);
            }
          }),
        );
        queryFulfilled.catch(patchResult.undo);
      },
    }),
  }),
});

export const {
  useGetSessionInfoQuery,
  useGetWishlistQuery,
  useGetCategoriesQuery,
  useAddToWishlistMutation,
  useRemoveFromWishlistMutation,
} = driessenstoffenApi;
